(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-footer"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.footer-menu-title:not(.footer-menu-title--social)').on('click', function () {
      const $block = $(this).closest('[data-footer-block]');
      const $list = $block.find('.main-footer__linkslist');
      const $toggle = $(this).find('.footer-toggle');

      if ($list.is(':visible')) {
        $list.slideUp(200);
        $toggle.html(
          '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 12 18" fill="none"><path d="M12 11.3314C11.364 11.3314 10.4143 11.9422 9.61714 12.5605C8.58857 13.3555 7.69114 14.3055 7.00628 15.3947C6.49286 16.2114 6 17.2014 6 17.998M6 17.998C6 17.2014 5.50714 16.2105 4.99371 15.3947C4.308 14.3055 3.41057 13.3555 2.38371 12.5605C1.58571 11.9422 0.634284 11.3314 -1.32453e-06 11.3314M6 17.998L6 0.498046" stroke="#121212"></path></svg>'
        );
      } else {
        $('.main-footer__linkslist').slideUp(200);
        $('.footer-toggle').html(
          '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 12 18" fill="none"><path d="M12 11.3314C11.364 11.3314 10.4143 11.9422 9.61714 12.5605C8.58857 13.3555 7.69114 14.3055 7.00628 15.3947C6.49286 16.2114 6 17.2014 6 17.998M6 17.998C6 17.2014 5.50714 16.2105 4.99371 15.3947C4.308 14.3055 3.41057 13.3555 2.38371 12.5605C1.58571 11.9422 0.634284 11.3314 -1.32453e-06 11.3314M6 17.998L6 0.498046" stroke="#121212"></path></svg>'
        );
        $list.slideDown(200);
        $toggle.html(
          '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 12 18" fill="none"><path d="M12 6.66667C11.364 6.66667 10.4143 6.05583 9.61714 5.4375C8.58857 4.6425 7.69114 3.6925 7.00628 2.60333C6.49286 1.78667 6 0.796667 6 5.24537e-07M6 5.24537e-07C6 0.796667 5.50714 1.7875 4.99371 2.60333C4.308 3.6925 3.41057 4.6425 2.38371 5.4375C1.58571 6.05583 0.634284 6.66667 -1.32453e-06 6.66667M6 5.24537e-07L6 17.5" stroke="#121212"/></svg>'
        );
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.collection-slider-swiper', {
      slidesPerView: 1.2,
      spaceBetween: 16,
      loop: true,
      pagination: {
        el: '.collection-slider--pagination',
        clickable: true
      },
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 4
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  function initRelatedSwiper() {
    const relatedSlider = document.querySelector('.related-slider-swiper');
    if (relatedSlider && !relatedSlider.classList.contains('swiper-initialized')) {
      new Swiper(relatedSlider, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        loop: true,
        pagination: {
          el: '.related-slider--pagination',
          clickable: true
        },
        breakpoints: {
          768: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3
          },
          1200: {
            slidesPerView: 4
          }
        }
      });
      relatedSlider.classList.add('swiper-initialized');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initRelatedSwiper();
    const observer = new MutationObserver(() => {
      initRelatedSwiper();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.reviews-swiper', {
      loop: true,
      pagination: {
        el: '.reviews-swiper-pagination',
        clickable: true,
      },
      spaceBetween: 10,
      navigation: {
        nextEl: '.custom-next',
        prevEl: '.custom-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.3,
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".reviews-swiper", {
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
